import { render, staticRenderFns } from "./NewProject.vue?vue&type=template&id=03ccab14&scoped=true&"
import script from "./NewProject.vue?vue&type=script&lang=js&"
export * from "./NewProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ccab14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03ccab14')) {
      api.createRecord('03ccab14', component.options)
    } else {
      api.reload('03ccab14', component.options)
    }
    module.hot.accept("./NewProject.vue?vue&type=template&id=03ccab14&scoped=true&", function () {
      api.rerender('03ccab14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/newProject/NewProject.vue"
export default component.exports